var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    {
      staticClass: "py-6"
    },
    [
      _c(
        "gg-card",
        [
          _c("gg-card-header", [
            _vm.isModeManual
              ? _c(
                  "div",
                  {
                    staticClass: "py-0"
                  },
                  [_vm._v(" What would you like to do? ")]
                )
              : _c("div", [
                  _vm._v(" Welcome to GreenGeeks Quick Launch Wizard. ")
                ])
          ]),
          _c(
            "gg-card-text",
            [
              !_vm.isModeManual
                ? _c("div", [
                    _c("p", [
                      _vm._v(
                        " You are now using our Quick Launch Wizard. Simply follow the steps below and you’ll be on your way to creating your online presence. If you are not sure what option is best for you, do not hesitate to contact our support team to help you. "
                      )
                    ]),
                    _c("p", [
                      _vm._v(
                        " You can always skip this wizard, and come back to it later by going to Hosting > Manage $domain > and then clicking Start Wizard. "
                      )
                    ])
                  ])
                : _vm._e(),
              _c("data-view", {
                attrs: {
                  items: _vm.items,
                  cols: "3",
                  svg: ""
                },
                model: {
                  value: _vm.selection,
                  callback: function callback($$v) {
                    _vm.selection = $$v
                  },
                  expression: "selection"
                }
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }